<script lang="ts">
  import { Icon, IconOptions, Marker } from "leaflet";
  import type { Map } from "leaflet";
  import { createEventDispatcher, getContext, onDestroy, onMount } from "svelte";

  const dispatch = createEventDispatcher();

  const handleClick = () => dispatch("click");
  const handleMouseout = () => dispatch("mouseout");
  const handleMouseover = () => dispatch("mouseover");

  const icon: IconOptions = {
    iconAnchor: [15, 43.5],
    iconSize: [30, 43.5],
    iconUrl: "",
    shadowAnchor: [22, 94],
    shadowSize: [68, 95],
    shadowUrl: "static/marker/shadow.png",
  };
  const activeIcon: Icon = new Icon({ ...icon, iconUrl: "static/marker/active.svg" });
  const defaultIcon: Icon = new Icon({ ...icon, iconUrl: "static/marker/default.svg" });
  const hoverIcon: Icon = new Icon({ ...icon, iconUrl: "static/marker/hover.svg" });

  const { getMap } = getContext("map");
  const map: Map = getMap();

  const marker: Marker = new Marker(null);

  export let active: boolean = false;
  export let hover: boolean = false;
  export let lat: number;
  export let lng: number;

  $: marker.setLatLng([lat, lng]);
  $: marker.setIcon(active ? activeIcon : hover ? hoverIcon : defaultIcon);

  onDestroy(() => {
    marker.off("click", handleClick);
    marker.remove();
  });

  onMount(() => {
    marker.on("click", handleClick);
    marker.on("mouseout", handleMouseout);
    marker.on("mouseover", handleMouseover);
    marker.addTo(map);
  });
</script>
